import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import ItemForm from './items/ItemForm';
import Item from '../../../models/Item';
import { createNewItem } from '../../../redux/ducks/items';
import FormResult from '../../../../src/FormResult';
import pageWrapper from '../../containers/MainPage';
import slugger from '../../../slugger';
import NewItemWizardForm from './items/addForms/NewItemWizardForm';
import Breadcrumbs from '../../common/Breadcrumbs';
import requiredAttributes from '../../../../src/config/requiredAttributes';

class NewItemPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      pickedStockItem: null,
      isWriting: false,
      addItemStatus: null,
    };
  }

  handleSubmit = (item, onSuccess, onFailure) => {
    const { history, onSubmit } = this.props;
    const successRedirect = (newItem) => {
      onSuccess();

      item.stockImageShow = true;

      const [subcatType, subcatKey] = newItem.getSubcategoryTypeAndKey();
      history.push(`/collections/${newItem.category}/${subcatType}/${slugger(subcatKey)}/${
        newItem.id
      }`,);
    };
    onSubmit(item, successRedirect, onFailure);
  };

  handlePickStockItem = (item, category) => {
    const isFromStock = item.id && item.id !== 0;

    const newItem = new Item({
      stockId: item.id,
      category,
      specificData: item.data,
      stockImage: item.stockImage,
    });

    switch (category) {
      case 'WATCH':
        newItem.itemData.title = isFromStock ? item.data.w_name : '';
        break;

      case 'CAR':
        newItem.itemData.title = isFromStock ? item.data.c_model : '';
        break;

      case 'OTHER':
        newItem.itemData.title = isFromStock ? item.data.w_name : '';
        break;

      case 'COMIC':
        newItem.itemData.title = isFromStock ? item.data.comic_series : '';
        break;

      // no default
    }

    if (!isFromStock) {
      const required = requiredAttributes[category];

      required.forEach((element) => {
        newItem.specificData[element.name] = element.value;
      });

      newItem.itemData.title = 'Untitled';
    }

    this.setState({ isWriting: true });

    // this.setState({ pickedStockItem: newItem });
    // this.props.onUpdateTitle(`Add a ${newItem.itemData.title}`);

    const onSuccess = () => {
      this.setState({ isWriting: false });
    };
    const onFailure = (status) => {
      this.setState({ isWriting: false });
      this.setState({ addItemStatus: new FormResult(status) });
    };

    this.handleSubmit(newItem, onSuccess, onFailure);
  };

  renderContents = () => {
    const { pickedStockItem, isWriting, addItemStatus } = this.state;

    if (pickedStockItem) {
      return <ItemForm item={pickedStockItem} onSubmit={this.handleSubmit} />;
    }

    return <NewItemWizardForm onPickItem={this.handlePickStockItem} isWriting={isWriting} addItemStatus={addItemStatus} />;
  };

  render() {
    return (
      <div>
        <Breadcrumbs
          segments={[
            { label: 'Collections', linkTo: '/collections' },
            { label: 'Add New' },
          ]}
        />
        {this.renderContents()}
      </div>
    );
  }
}

NewItemPage.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

function mapDispatchToProps(dispatch) {
  return {
    onSubmit: (item, onSuccess, onFailure) => {
      dispatch(createNewItem(item, onSuccess, onFailure));
    },
  };
}

export default pageWrapper(
  connect(undefined, mapDispatchToProps)(NewItemPage),
  'Add Item',
);



// WEBPACK FOOTER //
// ./src/components/pages/collections/NewItemPage.jsx